import PubSub from "pubsub-js";
import gsap from 'gsap';

var ListingFloorPlans = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-ListingFloorPlans',
	};

	$.extend(true, this.options, options);

};

ListingFloorPlans.prototype.init = function() {

	var self = this;

	this.$allFilters = this.options.$el.find(`.${self.options.baseClass}__filter`);
	this.$bedsFilterSelect = this.options.$el.find(`.${self.options.baseClass}__filter--beds select`);
	this.$floorPlanFilterSelect = this.options.$el.find(`.${self.options.baseClass}__filter--floorPlan select`);
	this.$floorPlansWrapper = this.options.$el.find(`.${self.options.baseClass}__listings`);
	this.$floorPlanItems = this.options.$el.find(`.${self.options.baseClass}__listingWrapper`);
	this.$floorPlanItemsClone = this.options.$el.find(`.${self.options.baseClass}__listingWrapper`).clone();
	this.$activeFloorPlanItems = this.$floorPlanItems;
	this.runFiltersTimeline = null;

	this.$allFilters.on('change', function() {
		self.runFilters();
	});

};

ListingFloorPlans.prototype.runFilters = function() {

	var self = this;
	console.log('update floor plans');
	this.updateActiveFloorPlans();
	console.log('call fun timeline');

	let floorPlansWrapperHeight = this.$floorPlansWrapper.outerHeight();
	
	gsap.timeline(
		{
			
		}
	)
	.to(self.$floorPlansWrapper.find(`.${self.options.baseClass}__listingWrapper`), {
		duration: 0.2,
		opacity: 0,
	})
	.set(self.$floorPlansWrapper, {
		height: floorPlansWrapperHeight
	})
	.set(self.$activeFloorPlanItems, {
		opacity: 0,
		y: 10
	})
	.add(function() {
		console.log('timeline running');
		self.$floorPlansWrapper.html( self.$activeFloorPlanItems );
		PubSub.publish('Sitewide:LazyLoadUpdate');
	})
	.to(self.$floorPlansWrapper, {
		height: 'auto',
		duration: 0.3
	})
	.to(self.$activeFloorPlanItems, {
		opacity: 1,
		y: 0,
		duration: 0.35,
		stagger: {
			each: 0.1
		},
	});

};

ListingFloorPlans.prototype.updateActiveFloorPlans = function() {

	var self = this;
	
	let $allFloorPlanElements = this.$floorPlanItemsClone.clone();

	let bedsFilterValue = this.$bedsFilterSelect.val();
	let floorPlanFilterValue = this.$floorPlanFilterSelect.val();

	let activeFloorPlanFindString = '';

	if (bedsFilterValue) {
		activeFloorPlanFindString += `[data-beds="${bedsFilterValue}"]`;
	}

	if (floorPlanFilterValue) {
		activeFloorPlanFindString += `[data-floor-plan-name="${floorPlanFilterValue}"]`;
	}

	if (activeFloorPlanFindString) {
		this.$activeFloorPlanItems = $allFloorPlanElements.filter(activeFloorPlanFindString);
	}
	else {
		this.$activeFloorPlanItems = $allFloorPlanElements;
	}
	

};

export default ListingFloorPlans;
